import { apiSlice } from '../apiSlice';

export interface WeeklyMePredictionResponse {
  id: string;
  userId: string;
  rashi?: string;
  prediction: any;
}

export interface PredictionChartMeta {
  location: string;
  time: string;
}

export interface PredictionChart {
  chartId: string;
  chartType: 'north' | 'south';
  imageUrl: string;
  startDate: string;
  endDate: string;
  meta: PredictionChartMeta;
}

export interface PredictionPeriodResponse {
  period: 'NextWeek' | 'NextMonth' | 'CurrentWeek' | 'CurrentMonth';
  startDate: string;
  endDate: string;
  charts: PredictionChart[];
}

export const mePredictionApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAdminCurrentWeekPrediction: builder.query<WeeklyMePredictionResponse, { userId: string; language?: string }>({
      query: ({ userId, language }) => ({
        url: `/admin/users/${userId}/predictions`,
        method: 'GET',
        params: { type: 'Weekly', period: 'CurrentWeek', ...(language ? { language } : {}) },
      }),
    }),

    getAdminNextWeekPrediction: builder.query<WeeklyMePredictionResponse, { userId: string; language?: string }>({
      query: ({ userId, language }) => ({
        url: `/admin/users/${userId}/predictions`,
        method: 'GET',
        params: { type: 'Weekly', period: 'NextWeek', ...(language ? { language } : {}) },
      }),
    }),

    // Transit Charts API (UNCHANGED)
    getPredictionByPeriod: builder.query<
      PredictionPeriodResponse,
      'NextWeek' | 'NextMonth' | 'CurrentWeek' | 'CurrentMonth'
    >({
      query: (period) => ({
        url: '/predictions',
        method: 'GET',
        params: { period },
      }),
    }),
  }),
});

export const {
  useLazyGetAdminCurrentWeekPredictionQuery,
  useLazyGetAdminNextWeekPredictionQuery,
  useLazyGetPredictionByPeriodQuery,
} = mePredictionApi;
